/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Failed_To_Load_TranslationInputs */

const en_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to load translation`)
};

const fr_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du chargement de la traduction`)
};

const de_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersetzung konnte nicht geladen werden`)
};

const it_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare la traduzione`)
};

const ru_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось загрузить перевод`)
};

const es_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar la traducción`)
};

const zh_cn2_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻译加载失败`)
};

const ja_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻訳を読み込めませんでした`)
};

const hi_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अनुवाद लोड करने में विफल`)
};

const pt_pt2_failed_to_load_translation = /** @type {(inputs: Failed_To_Load_TranslationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao carregar a tradução`)
};

/**
* | output |
* | --- |
* | "Failed to load translation" |
*
* @param {Failed_To_Load_TranslationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const failed_to_load_translation = /** @type {((inputs?: Failed_To_Load_TranslationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Failed_To_Load_TranslationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_failed_to_load_translation(inputs)
	if (locale === "de") return de_failed_to_load_translation(inputs)
	if (locale === "it") return it_failed_to_load_translation(inputs)
	if (locale === "ru") return ru_failed_to_load_translation(inputs)
	if (locale === "es") return es_failed_to_load_translation(inputs)
	if (locale === "zh-CN") return zh_cn2_failed_to_load_translation(inputs)
	if (locale === "ja") return ja_failed_to_load_translation(inputs)
	if (locale === "hi") return hi_failed_to_load_translation(inputs)
	if (locale === "pt-PT") return pt_pt2_failed_to_load_translation(inputs)
	return en_failed_to_load_translation(inputs)
});